module.exports = "<div class=\"text-circle\" ng-class=\"{'text-circle--light': $ctrl.lightTheme}\"> <ng-transclude></ng-transclude> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/accordian/components/textCircle/textCircle.html
// module id = 732
// module chunks = 0